import NoNavPage from "./components/NoNavPage";
import PricingSection from "./components/PricingSection";
import AboutSection from "./components/AboutSection";
import FeaturesSection from "./components/FeaturesSection";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router";
import { ArrowRight } from "lucide-react";

const LandingPage = () => {
  const navigate = useNavigate();
  return (
    <NoNavPage title="">
      <section className="w-full py-12 md:py-24 lg:py-32 xl:py-48">
        <div className="container px-4 md:px-6 mx-auto">
          <div className="flex flex-col items-center space-y-4 text-center">
            <div className="space-y-2">
              <h1 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl lg:text-6xl/none">
                Simplify APT Package Management
              </h1>
              <p className="mx-auto max-w-[700px] text-gray-500 md:text-xl dark:text-gray-400">
                AptFleet: Cloud-based solution for efficient APT package
                management across your Debian/Ubuntu-based server fleet.
              </p>
            </div>
            <div className="space-x-4">
              <Button
                className="w-fit group"
                size="lg"
                onClick={() => navigate("/learn-more")}
              >
                Learn More
                <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Button>
            </div>
          </div>
        </div>
      </section>

      <FeaturesSection />

      <AboutSection />

      <PricingSection />
    </NoNavPage>
  );
};

export default LandingPage;
